var _toConsumableArray = require("C:\\Users\\dariu\\Projekty\\elitehts-configurator-3d-simplified(configurator-lp)\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("C:\\Users\\dariu\\Projekty\\elitehts-configurator-3d-simplified(configurator-lp)\\node_modules\\@babel\\runtime/regenerator");

var _objectSpread = require("C:\\Users\\dariu\\Projekty\\elitehts-configurator-3d-simplified(configurator-lp)\\node_modules\\@babel\\runtime/helpers/objectSpread");

var _asyncToGenerator = require("C:\\Users\\dariu\\Projekty\\elitehts-configurator-3d-simplified(configurator-lp)\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _createClass = require("C:\\Users\\dariu\\Projekty\\elitehts-configurator-3d-simplified(configurator-lp)\\node_modules\\@babel\\runtime/helpers/createClass");

var _classCallCheck = require("C:\\Users\\dariu\\Projekty\\elitehts-configurator-3d-simplified(configurator-lp)\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("C:\\Users\\dariu\\Projekty\\elitehts-configurator-3d-simplified(configurator-lp)\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\dariu\\Projekty\\elitehts-configurator-3d-simplified(configurator-lp)\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\dariu\\Projekty\\elitehts-configurator-3d-simplified(configurator-lp)\\node_modules\\@babel\\runtime/helpers/inherits");

var _wrapNativeSuper = require("C:\\Users\\dariu\\Projekty\\elitehts-configurator-3d-simplified(configurator-lp)\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("@sketchfab/viewer-api")) : "function" == typeof define && define.amd ? define(["@sketchfab/viewer-api"], e) : "object" == typeof exports ? exports.sketchfabApiWrapper = e(require("@sketchfab/viewer-api")) : t.sketchfabApiWrapper = e(t.Sketchfab);
}(window, function (t) {
  return function (t) {
    var e = {};

    function i(a) {
      if (e[a]) return e[a].exports;
      var n = e[a] = {
        i: a,
        l: !1,
        exports: {}
      };
      return t[a].call(n.exports, n, n.exports, i), n.l = !0, n.exports;
    }

    return i.m = t, i.c = e, i.d = function (t, e, a) {
      i.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: a
      });
    }, i.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, i.t = function (t, e) {
      if (1 & e && (t = i(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var a = Object.create(null);
      if (i.r(a), Object.defineProperty(a, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var n in t) {
        i.d(a, n, function (e) {
          return t[e];
        }.bind(null, n));
      }
      return a;
    }, i.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return i.d(e, "a", e), e;
    }, i.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, i.p = "", i(i.s = 1);
  }([function (e, i) {
    e.exports = t;
  }, function (t, e, i) {
    "use strict";

    i.r(e);
    var a = i(0),
        n = i.n(a);

    function s(t, e) {
      var i = new XMLHttpRequest();
      i.onload = function () {
        var t = new FileReader();
        t.onloadend = function () {
          e(t.result);
        }, t.readAsDataURL(i.response);
      }, i.open("GET", t), i.responseType = "blob", i.send();
    }

    var r = function r(t) {
      return new Promise(function (e, i) {
        var a = new XMLHttpRequest();
        a.onload = function () {
          var t = new FileReader();
          t.onloadend = function () {
            e(t.result);
          }, t.readAsDataURL(a.response);
        }, a.open("GET", t), a.responseType = "blob", a.send();
      });
    },
        o = 2.4;

    function h(t) {
      var e = 0;
      return t < .04045 ? t >= 0 && (e = t * (1 / 12.92)) : e = Math.pow((t + .055) * (1 / 1.055), o), e;
    }

    var l = function l(t) {
      return function (t, e) {
        var i = e || new Array(t.length);
        if (!(t.length > 2 && t.length < 5)) throw new Error("Invalid color. Expected 3 or 4 components, but got " + t.length);
        return i[0] = h(t[0]), i[1] = h(t[1]), i[2] = h(t[2]), i.length > 3 && t.length > 3 && (i[3] = t[3]), i;
      }(function (t) {
        var e = t.match(/^#([0-9a-f]{6})$/i);
        if (e) return [parseInt(e[1].substr(0, 2), 16) / 255, parseInt(e[1].substr(2, 2), 16) / 255, parseInt(e[1].substr(4, 2), 16) / 255];
        throw new Error("Invalid color: " + t);
      }(t));
    };

    var u = {
      camera: 0,
      autostart: 1,
      autospin: 0,
      preload: 1,
      annotations_visible: 0,
      animation_autoplay: 1,
      ui_infos: 0,
      ui_annotations: 0,
      ui_controls: 0,
      ui_stop: 0,
      ui_help: 0,
      ui_hint: 0,
      ui_watermark: 0,
      transparent: 1,
      scrollwheel: 1,
      double_click: 1
    };

    var c =
    /*#__PURE__*/
    function (_Error) {
      _inherits(c, _Error);

      function c(t) {
        var _getPrototypeOf2;

        _classCallCheck(this, c);

        for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          e[_key - 1] = arguments[_key];
        }

        return _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(c)).call.apply(_getPrototypeOf2, [this, "Node with name \"".concat(t, "\" does not exist")].concat(e)));
      }

      return c;
    }(_wrapNativeSuper(Error));

    Error;
    Error;

    var d = function d(t, e) {
      if (!t.nodes_index[e]) throw new c(e);
      t.nodes_index[e].forEach(function (e) {
        t.api.hide(e);
      });
    },
        p = function p(t, e) {
      if (!t.nodes_index[e]) throw new c(e);
      t.nodes_index[e].forEach(function (e) {
        t.api.show(e);
      });
    },
        m = function m(t, e) {
      var i = Object.values(t.nodes).find(function (_ref) {
        var t = _ref.name;
        return t === e;
      });
      if (!i) throw new c(e);
      return i;
    };

    i.d(e, "default", function () {
      return f;
    });

    var f =
    /*#__PURE__*/
    function () {
      function f(t) {
        var _this = this;

        _classCallCheck(this, f);

        this.init =
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee3() {
          var t, e, _this$options$autosta, i;

          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  t = document.querySelector(_this.iframeQuery), e = new n.a(_this.version, t), _this$options$autosta = _this.options.autostart, i = _this$options$autosta === void 0 ? 0 : _this$options$autosta;
                  return _context3.abrupt("return", new Promise(function (t, i) {
                    return e.init(_this.uid, _objectSpread({
                      success: function () {
                        var _success = _asyncToGenerator(
                        /*#__PURE__*/
                        _regeneratorRuntime.mark(function _callee2(e) {
                          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                            while (1) {
                              switch (_context2.prev = _context2.next) {
                                case 0:
                                  _this.api = e, Object.assign(_this, e), e.start(), e.addEventListener("viewerready",
                                  /*#__PURE__*/
                                  _asyncToGenerator(
                                  /*#__PURE__*/
                                  _regeneratorRuntime.mark(function _callee() {
                                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                                      while (1) {
                                        switch (_context.prev = _context.next) {
                                          case 0:
                                            _context.next = 2;
                                            return _this._initPromises().then(function (i) {
                                              _this._loadTextures().then(function () {
                                                t(_objectSpread({}, _this, e));
                                              });
                                            }).catch(function (t) {
                                              console.error("Failed to init Api Wrapper", t), i(null);
                                            });

                                          case 2:
                                            return _context.abrupt("return", _context.sent);

                                          case 3:
                                          case "end":
                                            return _context.stop();
                                        }
                                      }
                                    }, _callee);
                                  })));

                                case 1:
                                case "end":
                                  return _context2.stop();
                              }
                            }
                          }, _callee2);
                        }));

                        function success(_x) {
                          return _success.apply(this, arguments);
                        }

                        return success;
                      }(),
                      error: function error(t) {
                        console.error("SF Viewer init error", t);
                      }
                    }, _this.options));
                  }));

                case 2:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        })), this._initPromises =
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee4() {
          var t;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  t = [_this._preloadTexturesByUrl(), _this._loadMaterials(), _this._loadAnnotations(), _this._loadAnimations(), _this._loadNodes(), _this._setupCameraRotation()];
                  return _context4.abrupt("return", Promise.all(t).then(function (t) {
                    return _this._setupMaterialsSwapping(), t;
                  }).catch(function (t) {
                    console.error(t);
                  }));

                case 2:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        })), this._preloadTexturesByUrl =
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee5() {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  return _context5.abrupt("return", new Promise(function (t, e) {
                    var _this2 = this;

                    if (this.texturesPreloadUrls) {
                      var _e = [];
                      return this.texturesPreloadUrls.forEach(function (t) {
                        _e.push(r(t).then(function (t) {
                          return _this2._addTexture(t);
                        }).then(function (e) {
                          return {
                            url: t,
                            tid: e
                          };
                        }));
                      }), t(Promise.all(_e).then(function (t) {
                        _this2.cashedTextures = t;
                      }));
                    }

                    t();
                  }.bind(_this)));

                case 1:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        })), this._loadAnnotations =
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee6() {
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  return _context6.abrupt("return", new Promise(function (t, e) {
                    var _this3 = this;

                    this.api.getAnnotationList(function (i, a) {
                      if (_this3.annotations = a, i) return e(i);
                      t(a);
                    });
                  }.bind(_this)));

                case 1:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        })), this._loadAnimations =
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee7() {
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  return _context7.abrupt("return", new Promise(function (t, e) {
                    var _this4 = this;

                    this.api.getAnimations(function (i, a) {
                      return _this4.animations = a, i ? e(i) : t(a);
                    });
                  }.bind(_this)));

                case 1:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        })), this._loadNodes =
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee8() {
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  return _context8.abrupt("return", new Promise(function (t, e) {
                    _this.api.getNodeMap(function (i, a) {
                      if (i) return e(i);
                      _this.nodes = a;
                      var n = [];
                      Object.keys(a).forEach(function (t) {
                        var e = a[t];
                        "object" == typeof n[e.name] ? n[e.name].push(e.instanceID) : n[e.name] = [e.instanceID];
                      }), _this.nodes_index = n, t(n);
                    });
                  }));

                case 1:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        })), this._loadMaterials =
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee9() {
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  return _context9.abrupt("return", (_this.api || Promise.reject("getMaterialList: API not ready"), new Promise(function (t, e) {
                    var _this5 = this;

                    this.api.getMaterialList(function (i, a) {
                      return i ? (console.error(i), e(i)) : (_this5.materials = a, t(a));
                    });
                  }.bind(_this))));

                case 1:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9);
        })), this._loadTextures =
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee10() {
          return _regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  return _context10.abrupt("return", (_this.api || Promise.reject("getTextureList: API not ready"), new Promise(function (t, e) {
                    var _this6 = this;

                    this.api.getTextureList(function (i, a) {
                      return _this6.textures = a, i ? (console.error(i), e(i)) : t(a);
                    });
                  }.bind(_this))));

                case 1:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10);
        })), this._setupCameraRotation =
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee11() {
          return _regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  return _context11.abrupt("return", (_this.api || Promise.reject("getCameraLookAt: API not ready"), new Promise(function (t, e) {
                    var _this7 = this;

                    this.api.getCameraLookAt(function (e, i) {
                      _this7.pov = i.position, _this7.tp = i.target, _this7.radius = Math.sqrt(Math.pow(_this7.pov[0] - _this7.tp[0], 2) + Math.pow(_this7.pov[1] - _this7.tp[1], 2) + Math.pow(_this7.pov[2] - _this7.tp[2], 2)), _this7.angle = 180 * Math.acos(_this7.pov[0] / _this7.radius) / Math.PI, t({
                        radius: _this7.radius,
                        angle: _this7.angle
                      });
                    });
                  }.bind(_this))));

                case 1:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11);
        })), this._setupMaterialsSwapping =
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee12() {
          var t;
          return _regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  if (!(!_this.api || !_this.materials)) {
                    _context12.next = 2;
                    break;
                  }

                  return _context12.abrupt("return", Promise.reject("API not ready"));

                case 2:
                  t = _toConsumableArray(Array(_this.materialMaxSources)).map(function (t, e) {
                    return "".concat(_this.materialPrefixSourceToSwap, "_").concat(("0" + (e + 1)).slice(-2));
                  });
                  return _context12.abrupt("return", new Promise(function (e, i) {
                    this.materialNamesToSwap = this.materialNamesToSwap || this.materials.map(function (t) {
                      return t.name;
                    }).filter(function (e) {
                      return t.includes(e);
                    }).sort(function (t, e) {
                      return t < e;
                    }), e(this.materialNamesToSwap);
                  }.bind(_this)));

                case 4:
                case "end":
                  return _context12.stop();
              }
            }
          }, _callee12);
        })), this._setMaterialColor = function (t, e) {
          var i = _this._getMaterialByName(t);

          var a = l(e);
          i.channels.AlbedoPBR.color = a, i.channels.DiffusePBR.color = a, i.channels.DiffuseColor.color = a, i.channels.AlbedoPBR.texture = void 0, i.channels.DiffusePBR.texture = void 0, i.channels.DiffuseColor.texture = void 0, _this.api.setMaterial(i, function (t, e) {
            t && console.error(t);
          });
        }, this._setMaterialTexture = function (t, e, i) {
          var a = _this._getMaterialByName(t);

          a.channels.AlbedoPBR.texture = _objectSpread({}, a.channels.AlbedoPBR.texture || {}, {
            uid: e
          }), i && (a.channels.NormalMap.texture.texCoordUnit = i, a.channels.CavityPBR.texture.texCoordUnit = i, a.channels.AlbedoPBR.texture.texCoordUnit = i), _this.api.setMaterial(a, function (t, e) {
            t && console.error(t);
          });
        }, this._setMaterialChannelTexture = function (t, e, i) {
          var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "AlbedoPBR";

          var n = _this._getMaterialByName(t);

          n.channels[a].texture = _objectSpread({}, n.channels[a].texture || {}, {
            uid: e
          }), i && (n.channels.NormalMap.texture.texCoordUnit = i, n.channels.CavityPBR.texture.texCoordUnit = i, n.channels.AlbedoPBR.texture.texCoordUnit = i), _this.api.setMaterial(n, function (t, e) {
            t && console.error(t);
          });
        }, this._addTexture = function (t) {
          return new Promise(function (e, i) {
            this.api.addTexture(t, function (t, a) {
              return t ? i(t) : e(a);
            });
          }.bind(_this));
        }, this._getMaterialByName = function (t, e) {
          return (e = e || _this.materials).reduce(function (e, i) {
            return i.name === t ? i : e;
          }, null);
        }, this._getAnnotationByName = function (t) {
          if (!_this.annotations) return null;
          var e = null;
          return _this.annotations.forEach(function (i, a) {
            i.name === t && (i.index = a, e = i);
          }), e;
        }, this._getAnimationByName = function (t) {
          if (!_this.animations) return null;
          var e = null;
          return _this.animations.forEach(function (i, a) {
            i[1] === t && (e = i);
          }), e;
        }, this._highlightNode = function (t, e) {
          var i = t.material;
          i.channels.EmitColor.factor = 1, i.channels.EmitColor.enable = !0, i.channels.EmitColor.color = e, _this.api.setMaterial(i);
        }, this._unhighlightNode = function (t, e) {
          var i = t.material;
          i.channels.EmitColor.factor = 1, i.channels.EmitColor.enable = !1, i.channels.EmitColor.color = e, _this.api.setMaterial(i);
        }, this.startHiglightNodeOnHover = function () {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [.1, .1, .3];
          _this.api.addEventListener("nodeMouseEnter", function (e) {
            return _this._highlightNode(e, t);
          }, {
            pick: "fast"
          }), _this.api.addEventListener("nodeMouseLeave", function (e) {
            return _this._unhighlightNode(e, t);
          }, {
            pick: "fast"
          });
        }, this.stopHiglightNodeOnHover = function () {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [.1, .1, .3];
          _this.api.removeEventListener("nodeMouseEnter", function (e) {
            return _this._highlightNode(e, t);
          }, {
            pick: "fast"
          }), _this.api.removeEventListener("nodeMouseLeave", function (e) {
            return _this._unhighlightNode(e, t);
          }, {
            pick: "fast"
          });
        }, this.setTextures = function (_ref13) {
          var _ref13$pairs = _ref13.pairs,
              t = _ref13$pairs === void 0 ? [] : _ref13$pairs,
              e = _ref13.target,
              _ref13$domain = _ref13.domain,
              i = _ref13$domain === void 0 ? window.location.origin : _ref13$domain,
              _ref13$assets_dir = _ref13.assets_dir,
              a = _ref13$assets_dir === void 0 ? "" : _ref13$assets_dir,
              _ref13$useBase = _ref13.useBase64,
              n = _ref13$useBase === void 0 ? !0 : _ref13$useBase,
              r = _ref13.texCoordUnit;
          var o = !1;
          t.forEach(function (t) {
            var h = t.channel,
                l = t.url,
                u = i + a + l;

            if (_this.cashedTextures && _this.cashedTextures.filter(function (t) {
              return t.url === u;
            }).length) {
              var _t = _this.cashedTextures.filter(function (t) {
                return t.url === u;
              })[0].tid;

              if (_t) return _this._setMaterialChannelTexture(e, _t, r, h);
            } else n ? s(u, function (t) {
              _this._addTexture(t).then(function (t) {
                (o = t) && _this._setMaterialChannelTexture(e, o, r, h);
              });
            }) : _this._addTexture(u).then(function (t) {
              (o = t) && _this._setMaterialChannelTexture(e, o, r, h);
            });
          });
        }, this.setTexture = function (_ref14) {
          var t = _ref14.url,
              e = _ref14.target,
              _ref14$domain = _ref14.domain,
              i = _ref14$domain === void 0 ? window.location.origin : _ref14$domain,
              _ref14$assets_dir = _ref14.assets_dir,
              a = _ref14$assets_dir === void 0 ? "" : _ref14$assets_dir,
              _ref14$useBase = _ref14.useBase64,
              n = _ref14$useBase === void 0 ? !0 : _ref14$useBase,
              r = _ref14.texCoordUnit;
          var o = !1;
          var h = i + a + t;
          if (!_this.cashedTextures || !_this.cashedTextures.filter(function (t) {
            return t.url === h;
          }).length) return n ? s(h, function (t) {
            return _this._addTexture(t).then(function (t) {
              (o = t) && _this._setMaterialTexture(e, o, r);
            });
          }) : _this._addTexture(h).then(function (t) {
            (o = t) && _this._setMaterialTexture(e, o, r);
          });
          {
            var _t2 = _this.cashedTextures.filter(function (t) {
              return t.url === h;
            })[0].tid;

            if (_t2) return _this._setMaterialTexture(e, _t2, r);
          }
        }, this.swapMaterial = function (_ref15) {
          var t = _ref15.source,
              e = _ref15.target;
          _this.materials_target = _this.materials_target || _toConsumableArray(_this.materials);

          var i = _this._getMaterialByName(e);

          _this._getMaterialByName(t, _this.materials_target);

          _this.api.setMaterial(i, function (t, e) {
            t && console.error(t);
          });
        }, this.node_hide = function (t) {
          return d(_this, t);
        }, this.node_show = function (t) {
          return p(_this, t);
        }, this.hideNode = function (t) {
          return d(_this, t);
        }, this.showNode = function (t) {
          return p(_this, t);
        }, this.extendAnnotations = function (t) {
          _this.api.addEventListener("annotationFocus", function (e) {
            console.log("Reached annotation " + e);
            var i = _this.annotations[e],
                a = t[i.name] || !1;

            if (console.warn(i.name), a && void 0 !== a.onStart) {
              console.warn("ANIMATION " + a.onStart.animation);

              var _t3 = _this._getAnimationByName(a.onStart.animation);

              console.warn([a, _t3]), _this.api.setCurrentAnimationByUID(_t3[0]), _this.api.seekTo(0), _this.api.setCycleMode(a.onStart.cycle), _this.api.setSpeed(1), _this.api.play();
            }
          }), _this.api.addEventListener("annotationBlur", function (t) {
            console.log("Left annotation " + t), _this.api.pause();
          });
        }, this.goToNextAnnotation = function () {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

          var i = function i(t) {
            return parseInt((t.match(/\d+/) || [])[0]);
          };

          var a = _this.annotations.filter(function (e) {
            return e.name.includes(t);
          });

          e && (a = a.sort(function (t, e) {
            return i(t.name) > i(e.name) ? 1 : i(e.name) > i(t.name) ? -1 : 0;
          }));
          var n = a.length;
          _this.currentAnnot++, _this.currentAnnot > n - 1 && (_this.currentAnnot = 0);

          var s = _this.annotations.map(function (t) {
            return t.uid;
          }).indexOf(a[_this.currentAnnot].uid);

          _this.api.gotoAnnotation(s);
        }, this.goToPrevAnnotation = function () {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

          var i = function i(t) {
            return parseInt((t.match(/\d+/) || [])[0]);
          };

          var a = _this.annotations.filter(function (e) {
            return e.name.includes(t);
          });

          e && (a = a.sort(function (t, e) {
            return i(t.name) > i(e.name) ? 1 : i(e.name) > i(t.name) ? -1 : 0;
          }));
          var n = a.length;
          _this.currentAnnot--, _this.currentAnnot < 0 && (_this.currentAnnot = n - 1);

          var s = _this.annotations.map(function (t) {
            return t.uid;
          }).indexOf(a[_this.currentAnnot].uid);

          _this.api.gotoAnnotation(s);
        }, this.setColor = function (_ref16) {
          var t = _ref16.material,
              e = _ref16.hexColor;
          console.warn([t, e]), Array.isArray(t) || (t = [t]), t.forEach(function (t) {
            _this._setMaterialColor(t, e);
          });
        }, this.moveCameraOnDeg = function (_ref17) {
          var _ref17$degree = _ref17.degree,
              t = _ref17$degree === void 0 ? _this.degree : _ref17$degree,
              _ref17$tp = _ref17.tp,
              e = _ref17$tp === void 0 ? _this.tp : _ref17$tp,
              _ref17$radius = _ref17.radius,
              i = _ref17$radius === void 0 ? _this.radius : _ref17$radius,
              _ref17$duration = _ref17.duration,
              a = _ref17$duration === void 0 ? _this.cameraEaseDuration : _ref17$duration;
          var n = t * Math.PI / 180;

          _this.api.lookat([e[0] + i * Math.cos(n), e[1] + i * Math.sin(n), e[2]], e, a);
        }, this.startRotationLeft = function () {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
          _this.api && (_this.stopAutoRotation(), _this.rotateLeftInterval = setInterval(function () {
            _this.angle += _this.rotationDegreeInterval, _this.moveCameraOnDeg({
              pov: _this.pov,
              tp: _this.tp,
              radius: _this.radius,
              degree: _this.angle,
              duration: _this.cameraEaseDuration
            });
          }, _this.rotationTimeInterval), t());
        }, this.stopRotationLeft = function () {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
          _this.rotateLeftInterval && clearInterval(_this.rotateLeftInterval), t();
        }, this.startRotationRight = function () {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
          _this.api && (_this.stopAutoRotation(), _this.rotateRightInterval = setInterval(function () {
            _this.angle -= _this.rotationDegreeInterval, _this.moveCameraOnDeg({
              pov: _this.pov,
              tp: _this.tp,
              radius: _this.radius,
              degree: _this.angle,
              duration: _this.cameraEaseDuration
            });
          }, _this.rotationTimeInterval), t());
        }, this.stopRotationRight = function () {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
          _this.rotateRightInterval && clearInterval(_this.rotateRightInterval), t();
        }, this.startAutoRotation = function () {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

          if (_this.api) {
            var _e2 = !0;

            _this.rotateAutoInterval = setInterval(function () {
              _e2 ? _this.angle < 180 ? _this.angle += _this.rotationDegreeInterval : _this.angle >= 180 && (_e2 = !1, _this.angle -= _this.rotationDegreeInterval) : _this.angle > -180 ? _this.angle -= _this.rotationDegreeInterval : _this.angle <= -180 && (_e2 = !0, _this.angle += _this.rotationDegreeInterval), _this.moveCameraOnDeg({
                pov: _this.pov,
                tp: _this.tp,
                radius: _this.radius,
                degree: _this.angle,
                duration: _this.cameraEaseDuration
              });
            }, _this.rotationTimeInterval), t();
          }
        }, this.stopAutoRotation = function () {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
          _this.rotateAutoInterval && clearInterval(_this.rotateAutoInterval), t();
        }, this.startAutoSwapping = function () {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
          _this.api && (_this.materialIndex || (_this.materialIndex = 0), _this.autoSwapInterval = setInterval(function () {
            _this.swapMaterial({
              source: _this.materialNamesToSwap[_this.materialIndex],
              target: _this.materialTargetToSwap
            }), _this.materialIndex++, _this.materialIndex >= _this.materialNamesToSwap.length && (_this.materialIndex = 0);
          }, _this.materialSwapTimeInterval), t());
        }, this.stopAutoSwapping = function () {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
          _this.autoSwapInterval && clearInterval(_this.autoSwapInterval), t();
        }, this.findNodeByName = function (t) {
          return m(_this, t);
        }, this.transformNode = function (t, e) {
          return transformNode(_this, t, e);
        };

        var _t$useSingleton = t.useSingleton,
            e = _t$useSingleton === void 0 ? !0 : _t$useSingleton,
            _t$version = t.version,
            i = _t$version === void 0 ? null : _t$version,
            _t$iframeQuery = t.iframeQuery,
            a = _t$iframeQuery === void 0 ? "#api-frame" : _t$iframeQuery,
            _t$uid = t.uid,
            o = _t$uid === void 0 ? null : _t$uid,
            _t$options = t.options,
            h = _t$options === void 0 ? u : _t$options,
            _t$rotationDegreeInte = t.rotationDegreeInterval,
            c = _t$rotationDegreeInte === void 0 ? 6 : _t$rotationDegreeInte,
            _t$rotationTimeInterv = t.rotationTimeInterval,
            g = _t$rotationTimeInterv === void 0 ? 100 : _t$rotationTimeInterv,
            _t$cameraEaseDuration = t.cameraEaseDuration,
            v = _t$cameraEaseDuration === void 0 ? 2 : _t$cameraEaseDuration,
            _t$materialNamesToSwa = t.materialNamesToSwap,
            x = _t$materialNamesToSwa === void 0 ? null : _t$materialNamesToSwa,
            _t$materialTargetToSw = t.materialTargetToSwap,
            _ = _t$materialTargetToSw === void 0 ? "surface_01" : _t$materialTargetToSw,
            _t$materialPrefixSour = t.materialPrefixSourceToSwap,
            w = _t$materialPrefixSour === void 0 ? "mat" : _t$materialPrefixSour,
            _t$materialMaxSources = t.materialMaxSources,
            T = _t$materialMaxSources === void 0 ? 6 : _t$materialMaxSources,
            _t$materialSwapTimeIn = t.materialSwapTimeInterval,
            y = _t$materialSwapTimeIn === void 0 ? 1e3 : _t$materialSwapTimeIn,
            _t$texturesPreloadUrl = t.texturesPreloadUrls,
            I = _t$texturesPreloadUrl === void 0 ? null : _t$texturesPreloadUrl;

        if (e && f._instance) return f._instance;
        i && (this.version = i), this.iframeQuery = a, this.uid = o, this.options = h, this.texturesPreloadUrls = I, this.rotationDegreeInterval = c, this.tp = 0, this.pov = 0, this.angle = 0, this.radius = null, this.rotationTimeInterval = g, this.cameraEaseDuration = v, this.materialTargetToSwap = _, this.materialPrefixSourceToSwap = w, this.materialMaxSources = T, this.materialNamesToSwap = x, this.materialSwapTimeInterval = y, this.api = null, this.nodes = !1, this.nodes_index = !1, this.materials = !1, this.textures = !1, this.annotations = !1, this.animations = !1, this.currentAnnot = 1, this.hexToLiner = l, f._instance = this;
      }

      _createClass(f, [{
        key: "instance",
        get: function get() {
          return f._instance;
        }
      }]);

      return f;
    }();
  }]);
});